import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {ucFirst} from "@/Helpers/Function";
import Link from "@/Layouts/Link";
import "@/Scss/Site/Catalog/tag.scss";

const Tags = (props) => {
    const {tagOne = []} = props;

    if (tagOne.length === 0) return null;

    return (
        <div className={`tags`}>
            <div className={`tags__title`}>С этими товарами ищут</div>
            <div className={`tags__list`}>
                {tagOne.map((el, i) => {
                    return <Link key={i} href={`${el.href}`} className={`tags__item`}>
                        {ucFirst(el.value)}
                    </Link>
                })}
            </div>
        </div>
    );
}

export default useWithStore(Tags);
